/* Dolci Vita header v2 (dvh2) - animated search placeholder rotator.
   Types a rotating example term after "Try searching for... ".
   Runs once, pauses while the input is focused, and respects
   prefers-reduced-motion (shows the first term statically). */
(function () {
  'use strict';

  if (window.__dvh2RotatorInit) return;
  window.__dvh2RotatorInit = true;

  var TERMS = [
    'Party Dresses',
    'Cocktail Dresses',
    'Swimwear',
    'Wedding Guest',
    'Occasion Wear',
    'Bodysuits',
    'Going Out Tops'
  ];

  var TYPE_MS = 90;    // per character while typing
  var DELETE_MS = 45;  // per character while deleting
  var HOLD_MS = 1500;  // pause when a full term is shown
  var GAP_MS = 350;    // pause between terms
  var START_MS = 600;  // initial delay

  function init() {
    var rot = document.querySelector('[data-dvh2-rotator]');
    if (!rot) return;

    var form = rot.closest('[data-dvh2-search]') || rot.closest('form');
    var input = form ? form.querySelector('.dvh2-search__input') : null;

    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      rot.textContent = TERMS[0];
      return;
    }

    var paused = false;
    var hasValue = false;

    function syncValue() {
      hasValue = !!(input && input.value && input.value.trim().length > 0);
      if (form) form.classList.toggle('dvh2-has-value', hasValue);
    }

    if (input) {
      input.addEventListener('focus', function () { paused = true; });
      input.addEventListener('blur', function () { paused = false; syncValue(); });
      input.addEventListener('input', syncValue);
      syncValue();
    }

    var termIndex = 0;
    var charIndex = 0;
    var deleting = false;

    function tick() {
      // While the user is interacting, keep the rotator empty and idle.
      if (paused || hasValue) {
        rot.textContent = '';
        charIndex = 0;
        deleting = false;
        setTimeout(tick, 400);
        return;
      }

      var term = TERMS[termIndex];

      if (!deleting) {
        charIndex++;
        rot.textContent = term.slice(0, charIndex);
        if (charIndex >= term.length) {
          deleting = true;
          setTimeout(tick, HOLD_MS);
          return;
        }
        setTimeout(tick, TYPE_MS);
      } else {
        charIndex--;
        rot.textContent = term.slice(0, Math.max(charIndex, 0));
        if (charIndex <= 0) {
          deleting = false;
          termIndex = (termIndex + 1) % TERMS.length;
          setTimeout(tick, GAP_MS);
          return;
        }
        setTimeout(tick, DELETE_MS);
      }
    }

    setTimeout(tick, START_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
